import { createFileRoute, Navigate } from '@tanstack/react-router'
import { useCompanyCaller } from '@/app/company'
import { NothingForRole } from '@/app/nothing-for-role'
import { companySections } from '@/domain/abilities'

export const Route = createFileRoute('/_app/c/$orgId/')({
  component: CompanyHome,
})

/// A company opens on its first section the caller may see — or says
/// plainly that there is nothing here for their role yet. Whoever reads the
/// club's figures opens on them («Огляд», specs/reports.md §8.4).
function CompanyHome() {
  const { orgId } = Route.useParams()
  const { caller } = useCompanyCaller(orgId)
  const sections = companySections(caller)
  // A trainer (scope `own`) opens on their own day: the sessions to mark and
  // the month's pay (specs/payroll-periods.md §6).
  if (caller.profile.scope === 'own' && sections.includes('mywork')) {
    return <Navigate to="/c/$orgId/my-work" params={{ orgId }} replace />
  }
  if (sections.includes('overview')) {
    return <Navigate to="/c/$orgId/overview" params={{ orgId }} replace />
  }
  if (sections.includes('clients')) {
    return <Navigate to="/c/$orgId/clients" params={{ orgId }} replace />
  }
  if (sections.includes('staff')) {
    return <Navigate to="/c/$orgId/staff" params={{ orgId }} replace />
  }
  if (sections.includes('branches')) {
    return <Navigate to="/c/$orgId/branches" params={{ orgId }} replace />
  }
  if (sections.includes('passes')) {
    return <Navigate to="/c/$orgId/passes" params={{ orgId }} replace />
  }
  if (sections.includes('goods')) {
    return <Navigate to="/c/$orgId/goods" params={{ orgId }} replace />
  }
  if (sections.includes('services')) {
    return <Navigate to="/c/$orgId/services" params={{ orgId }} replace />
  }
  if (sections.includes('cash')) {
    return <Navigate to="/c/$orgId/cash" params={{ orgId }} replace />
  }
  if (sections.includes('payroll')) {
    return <Navigate to="/c/$orgId/payroll" params={{ orgId }} replace />
  }
  if (sections.includes('settings')) {
    return <Navigate to="/c/$orgId/settings" params={{ orgId }} replace />
  }
  if (sections.includes('mywork')) {
    return <Navigate to="/c/$orgId/my-work" params={{ orgId }} replace />
  }
  return <NothingForRole />
}
